export default __webpack_public_path__ + "static/media/vendor-spiker5.15d6d4f7.jpg";